var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM8.76712 8.35616C8.76712 7.67527 9.3191 7.12329 10 7.12329C10.6809 7.12329 11.2329 7.67527 11.2329 8.35616V16.0274C11.2329 16.7083 10.6809 17.2603 10 17.2603C9.3191 17.2603 8.76712 16.7083 8.76712 16.0274V8.35616ZM10 2.73973C9.16779 2.73973 8.49315 3.41437 8.49315 4.24658C8.49315 5.07878 9.16779 5.75342 10 5.75342C10.8322 5.75342 11.5068 5.07878 11.5068 4.24658C11.5068 3.41437 10.8322 2.73973 10 2.73973Z",
    fill: "#CC2364"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d53d3ce0.svg";
export { ForwardRef as ReactComponent };